import { Link, useSearchParams } from 'react-router-dom';

import BoardViewIcon from '../../../common/icons/board-view';
import ListViewIcon from '../../../common/icons/list-view';
import { ROUTES } from '../../../core/constants/routes';
import { BOARD_PARAMS } from '../utils/board';

import '../styles/view-switch.css';

const VIEWS = [
    { key: 'tablero', label: 'Vista de tablero', Icon: BoardViewIcon },
    { key: 'lista', label: 'Vista de lista', Icon: ListViewIcon },
];

// Both views share the project filter, so it travels with the switch.
export default function ViewSwitch({ current }) {
    const [params] = useSearchParams();
    const project = params.get(BOARD_PARAMS.PROJECT);

    const hrefFor = (key) => {
        const next = new URLSearchParams();
        if (project) next.set(BOARD_PARAMS.PROJECT, project);
        if (key === 'lista') next.set(BOARD_PARAMS.VIEW, 'lista');
        const query = next.toString();
        return query ? `${ROUTES.WORK}?${query}` : ROUTES.WORK;
    };

    return (
        <nav className="view-switch" aria-label="Vista del trabajo">
            {VIEWS.map((view) => (
                <Link
                    key={view.key}
                    to={hrefFor(view.key)}
                    replace
                    aria-current={current === view.key ? 'page' : undefined}
                    aria-label={view.label}
                    title={view.label}
                    className={`view-switch__option${current === view.key ? ' view-switch__option--on' : ''}`}
                >
                    <view.Icon size={20} />
                </Link>
            ))}
        </nav>
    );
}
